import { sharedEffects } from 'shared-lib'

export const effects = { ...sharedEffects }
